import Grid from '@material-ui/core/Grid';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';

import Collection from '../Model/Collection';

import ItemTableRow from '../Components/ItemTableRow';
import UserActivityCard from '../Support/Components/UserActivityCard';
import UserActivityCollectionFields from '../Model/UserActivityCollectionFields';

import {
  GetDateValue,
  GetUserValue,
  GetBoolValue,
} from '../Util/Properties';

import {
  GetSupportUserActivityPathForApi,
} from '../Util/api';

export class SupportUserActivity_Collection extends Collection {
  constructor(props, onSetState, onApiError, isWorkspace, isProjects) {
    super(props, onSetState, onApiError, isWorkspace, isProjects);

    this.PageTitle = "Users";
    this.ContentUri = GetSupportUserActivityPathForApi();
    this.CollectionName = "SupportUserActivity";
    this.ItemsName = "LoginSessions";
    this.ItemName = "LoginSession";
    this.DefaultViewType = "List";
  }

  HandleGetCollectionFieldsPromise = () => Promise.resolve(UserActivityCollectionFields);

  HandleGetHeadCells = (items, sensitiveFields) => [
    { id: 'UserEmail', numeric: false, label: 'Email' },
    { id: 'LastActivity', numeric: false, label: 'Last Activity' },
    // { id: 'CreatedOn', numeric: false, label: 'Session Created On' },
    { id: 'UserProvider', numeric: false, label: 'Sign-in Provider' },
    { id: 'IsMobile', numeric: false, label: 'Mobile' },
    { id: 'BrowserFingerprint', numeric: false, label: 'Fingerprint' },
  ];

  HandleGetCardGridItems = (items, sensitiveFields, classes, theme, onSelect, selectedIDs, onAction, postActionData, sortType, sortDescending) => {
    return (items && items.length) 
      ? items
        .map(i => {
          return (
            <Grid item key={i.ID} sm={12} md={6} lg={4} xl={3} className={classes.cardGridItem}>
              <UserActivityCard
                LoginSession={i}
                // onCardAction={undefined}
              />
            </Grid>
          );
        }) 
      : [];
  }

  HandleGetTableRows = (headCells, items, sensitiveFields, classes, theme, onSelect, selectedIDs, onAction, postActionData, sortType, sortDescending) => {
    return (items && items.length)
      ? items
        .map(i => {
          return (
            <ItemTableRow key={`k_${i.ID}`}>
              <TableCell className={classes.tableCell_FirstCell} padding="checkbox">
                <Checkbox
                  style={{
                    visibility: "hidden",
                  }}
                  color="secondary"
                />
              </TableCell>
              <TableCell className={classes.tableCell} component="th" id={`label_${i.ID}`} scope="row" padding="none">
                {GetUserValue(i.UserEmail, i.UserName)}
              </TableCell>
              <TableCell className={classes.tableCell}>{GetDateValue(i.LastActivity)}</TableCell>
              {/*<TableCell className={classes.tableCell}>{GetDateValue(i.CreatedOn)}</TableCell>*/}
              <TableCell className={classes.tableCell}>{i.UserProvider}</TableCell>
              <TableCell className={classes.tableCell}>{GetBoolValue(i.IsMobile)}</TableCell>
              <TableCell className={classes.tableCell}>{i.BrowserFingerprint}</TableCell>
            </ItemTableRow>
          );
        }) 
      : [];
  }
}